import * as React from "react";

const LinkedinIconBrand = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="56"
    height="56"
    viewBox="0 0 41 40"
    fill="none"
  >
    <rect x="0.5" width="40" height="40" rx="20" fill="#0A66C2" />
    <path
      d="M27.5392 27.0433H24.5775V22.4025C24.5775 21.2958 24.555 19.8717 23.0342 19.8717C21.49 19.8717 21.2542 21.0758 21.2542 22.3208V27.0433H18.2925V17.5H21.1375V18.8008H21.1758C21.5733 18.0508 22.54 17.2592 23.9842 17.2592C26.985 17.2592 27.54 19.2342 27.54 21.805V27.0433H27.5392ZM14.9475 16.1942C13.9942 16.1942 13.2283 15.4225 13.2283 14.4733C13.2283 13.525 13.995 12.7542 14.9475 12.7542C15.8975 12.7542 16.6675 13.525 16.6675 14.4733C16.6675 15.4225 15.8967 16.1942 14.9475 16.1942ZM16.4325 27.0433H13.4625V17.5H16.4325V27.0433ZM29.0208 10H11.9758C11.16 10 10.5 10.645 10.5 11.4408V28.5592C10.5 29.3558 11.16 30 11.9758 30H29.0183C29.8333 30 30.5 29.3558 30.5 28.5592V11.4408C30.5 10.645 29.8333 10 29.0183 10H29.0208Z"
      fill="white"
    />
  </svg>
);

export default LinkedinIconBrand;
